import { Add } from '@mui/icons-material'
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@mui/material'
import { CenteringBox } from 'components/CenteringBox'
import { useCallback, useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'
import { AddRejectedSubmitterOrganizationForm } from '../subforms/add-rejected-submitter-organizations'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const RejectedSubmitterOrganizationsTable = ({ protocolData }: Props) => {
  const [rejectedSubmitterOrganizationForm, setRejectedSubmitterOrganizationForm] =
    useState(false)
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append } = useFieldArray({
    control,
    name: `rejectedSubmitterOrganizations`,
  })

  const handleFormClose = useCallback(() => {
    setRejectedSubmitterOrganizationForm(false)
  }, [])

  const handleAddClick = useCallback(() => {
    setRejectedSubmitterOrganizationForm(true)
  }, [])

  const handleFormSubmit = useCallback((values: any) => {
    append(values)
  }, [])

  return (
    <>
      {rejectedSubmitterOrganizationForm && (
        <AddRejectedSubmitterOrganizationForm
          handleClose={handleFormClose}
          onAdd={handleFormSubmit}
        />
      )}
      <TableContainer>
        <Table
          sx={{
            tableLayout: 'fixed',
            background: '#FFF',
            '& td, th': {
              border: '1px solid #ccc',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>{t('ordinal')}</TableCell>
              <TableCell>{t('supplier-name')}</TableCell>
              <TableCell>{t('reason')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <StyledTableCell>
                    <Controller
                      name={`rejectedSubmitterOrganizations.${index}.orgName`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Controller
                      name={`rejectedSubmitterOrganizations.${index}.reason`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <CenteringBox my={2}>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={handleAddClick}
        >
          <Add />
        </Button>
      </CenteringBox>
    </>
  )
}
